<script setup lang="ts">

import { usePresentation } from '@presentation/Types/Presentation';

type Props = { src: string, title?: string }
const { src, title = 'Play Video' } = defineProps<Props>();
const presentation = usePresentation();

</script>

<template>

    <div class="flex flex-col justify-center items-center z-50">
        <div class="rounded-full ring-[7px] ring-gray-900/50">
            <button 
                class="
                    group
                    rounded-full w-16 h-16 ring-4 ring-white/50 flex items-center justify-center
                    transition-all duration-150
                    bg-white/10 shadow-xl
                    hover:!ring-white
                "
                @click="() => presentation.displayMedia( src )">
                <div class="absolute bottom-0 left-0 w-full h-1/2 rounded-b-full bg-gradient-to-b from-white/5 via-30% via-transparent to-transparent" />
                <Icon name="play" class="text-2xl opacity-60 group-hover:opacity-100" />
            </button>
        </div>
        <div class="tracking-wider flex text-center mt-2">{{ title }}</div>
    </div>

</template>